import { model as i18n } from '!/i18n'
import { combine } from 'effector'

export const $libraryPurchasedMoviesTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    movies: t('movies_purchased'),
  })
)
